import httpClient from '@/lib/httpClient.js'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

export default function usePlaceTransactionCategoryInGroup() {
  const queryClient = useQueryClient()

  const action = async ({ categoryId, groupId, sortOrder }) => {
    const response = await httpClient.post(
      `/team/transaction-category/${categoryId}/place-in-group`,
      {
        group_id: groupId,
      },
    )

    await httpClient.put(`team/transaction-category/sort-order`, {
      id: categoryId,
      entity_type: 'transaction_categories',
      sort_order: sortOrder,
    })
    return response
  }

  const mutation = useMutation({
    mutationFn: action,
    onError: (e) => {
      toast.error(e?.response?.data?.message ?? 'An error occurred.')
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['transaction-categories'] })
    },
  })

  return {
    action: mutation.mutateAsync,
    status: mutation,
  }
}
